/**
 * Layout Controller
 */
(function() {
	angular.module('app.layout').controller('ShellController', ShellController);

	ShellController.$inject = ['$location', '$scope', 'authenticationSettings'];
	function ShellController($location, $scope, authenticationSettings) {
		var vm = this;
		vm.redirect = $scope.$root.redirectURL;
		vm.logoUrl = authenticationSettings.dynamicContentUrl + '/1234/x/images/solera-autopoint_logo2019.svg';
		$scope.$root.date = new Date();

		if ($location.search().thirdparty && $location.search().thirdparty.toLowerCase() === 'redcap') {
			vm.hideHeader = true;
			angular.element('body').css('background-color', '#ffffff');
			angular.element('#wrapper').css('width', '100%');
			angular.element('.login-page').css('background-image', 'none');
		}
	}
})();
